<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Parameter</h4>
            <div v-if="action !== 'new'" class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ID</label>
              <label class="col-form-label col-lg-8">{{
                createModel.applicationId
              }}</label>
            </div>
            <validationObserver ref="addParameterForm" tag="form">
              <form @submit.prevent="onSubmit">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Column Key</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="column_key"
                      name="Column Key"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="column_key"
                        name="column_key"
                        v-model="createModel.column_key"
                        type="text"
                        class="form-control"
                        placeholder="Column Key"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.column_key,
                        }"
                        v-on:keyup="onValidateColumnKey($event)"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Column Name</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="column_name"
                      name="Column Name"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="column_name"
                        name="column_name"
                        v-model="createModel.column_name"
                        type="text"
                        class="form-control"
                        placeholder="Column Name"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.column_name,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Display Name</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="display_name"
                      name="Display Name"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="display_name"
                        name="display_name"
                        v-model="createModel.display_name"
                        type="text"
                        class="form-control"
                        placeholder="Display Name"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.display_name,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-lg-2 col-form-label">Source Of Data</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-if="isSourceJson"
                      v-slot="{ errors }"
                      ref="source_of_data"
                      name="Source Of Data"
                      :rules="{ required: true, validateJson: true }"
                    >
                      <textarea
                        id="source_of_data"
                        name="source_of_data"
                        class="form-control"
                        placeholder="Source Of Data"
                        rows="5"
                        v-model="createModel.source_of_data"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.source_of_data,
                        }"
                      ></textarea>
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                    <validationProvider
                      v-else
                      v-slot="{ errors }"
                      ref="source_of_data"
                      name="Source Of Data"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="source_of_data"
                        name="source_of_data"
                        v-model="createModel.source_of_data"
                        type="text"
                        class="form-control"
                        placeholder="Source Of Data"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.source_of_data,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"
                    >Source Of Data Type
                  </label>
                  <div class="col-lg-8">
                    <div class="row">
                      <div class="col-lg-12 mb-4">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="source_of_data_type"
                          name="Source Of Data Type"
                          :rules="{
                            required: true,
                          }"
                        >
                          <multiselect
                            v-model="createModel.source_of_data_type"
                            :options="sourceDataTypeOptions"
                            :class="{ 'is-invalid': errors.length }"
                          ></multiselect>
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-4 text-center">
                  <div class="button-items">
                    <button type="submit" class="btn btn-primary">Save</button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="onCancel()"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";

import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import parameterService from "@/helpers/service/parameter-provider";
import Multiselect from "vue-multiselect";
import { eventBus } from "@/main.js";
const _ = require("underscore");

import { SourceDataTypeEnum } from "@/enum/parameter.enum.js";
import { parameterComputed, parameterMethods } from "@/state/helpers";
/**
 * Projects-create component
 */
export default {
  page: {
    title: "Create New Parameter",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 120,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
      },
      applicationId: "",
      serviceId: "",
      action: "new",
      title: "Create New Parameter",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Parameter",
          href: "/Parameters",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      createModel: {
        applicationId: "",
        serviceId: "",
        column_key: "",
        column_key_old: "",
        column_name: "",
        display_name: "",
        source_of_data: "",
        source_of_data_type: "",
      },
      oldData: {},
      sourceDataTypeOptions: ["Table", "API", "Json"],
      tokenExpiryOptions: [
        { name: "1 ชั่วโมง", value: 60 },
        { name: "1 วัน", value: 1440 },
        { name: "1 ปี", value: 21900 },
      ],
      isDuplicate: false,
    };
  },
  watch: {
    "createModel.source_of_data_type": {
      handler(val, oldVal) {
        if (this.$validate.isValid(val) && this.$validate.isValid(oldVal))
          this.createModel.source_of_data = "";
      },
    },
  },
  computed: {
    ...parameterComputed,
    isSourceJson() {
      return this.createModel.source_of_data_type === "Json";
    },
  },
  created: function () {
    this.applicationId = this.$route.params.id;
    this.serviceId = this.$route.params.serviceId;
    this.parameterId = this.$route.params.parameterId;
    //console.log(this.applicationId, this.serviceId, this.parameterId);
    if (this.parameterId === "new") {
      this.action = "new";
      this.title = "Create";
    } else {
      this.action = "edit";
      this.title = "Edit";
    }
  },
  mounted: function () {
    if (this.action === "edit") {
      this.getDetail();
    }
  },
  methods: {
    ...parameterMethods,
    async getDetail() {
      let result = await parameterService.getParameterAsync(
        this.applicationId,
        this.serviceId,
        this.parameterId
      );
      if (result.status === 200) {
        this.createModel = result.data;
        this.createModel.column_key_old = result.data.column_key;
        this.oldData = Object.assign({}, this.createModel);
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onSubmit() {
      this.$refs.addParameterForm.validate().then(async (result) => {
        if (result) {
          if (this.action === "new") {
            let result = await parameterService.createParameterAsync(
              this.applicationId,
              this.serviceId,
              this.createModel
            );
            if (result.status === 201) {
              // eventBus.$emit("info-modal", "เพิ่มข้อมูลสำเร็จ");
              this.$utils.notification("success", "Success", 1500);

              this.$router.push({
                name: "service_detail",
                params: { id: this.applicationId, serviceId: this.serviceId },
              });
              // this.clearForm();
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          } else {
            if (_.isEqual(this.createModel, this.oldData)) {
              this.$router.push({
                name: "service_detail",
                params: { id: this.applicationId, serviceId: this.serviceId },
              });
              return;
            }

            let result = await parameterService.updateParameterAsync(
              this.applicationId,
              this.serviceId,
              this.parameterId,
              this.createModel
            );
            if (result.status == 204) {
              // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
              this.$utils.notification("success", "Success", 1500);

              this.$router.push({
                name: "service_detail",
                params: { id: this.applicationId, serviceId: this.serviceId },
              });
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          }
        }
      });
    },
    onCancel() {
      this.$router.push({
        name: "application_detail",
        params: { id: this.applicationId },
      });
    },
    async onValidateColumnKey() {
      if (
        !(
          this.createModel.column_key.trim() === "" ||
          this.createModel.column_key.trim() === null ||
          this.createModel.column_key.trim() === undefined
        )
      ) {
        if (
          this.action === "edit" &&
          this.createModel.column_key_old == this.createModel.column_key.trim()
        ) {
          return;
        }

        let params = new URLSearchParams();
        params.append("column_key", this.createModel.column_key.trim());
        let result = await parameterService.headParameterAsync(
          this.applicationId,
          this.serviceId,
          params
        );
        if (result.status === 200) {
          this.isDuplicate = true;
        } else if (result.response.status === 404) {
          this.isDuplicate = false;
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      }
    },
    clearForm() {
      this.createModel = {
        applicationId: "",
        serviceId: "",
        column_key: "",
        column_key_old: "",
        column_name: "",
        display_name: "",
        source_of_data: "",
        source_of_data_type: "",
      };
    },
  },
};
</script>

<style scoped>
.switches-channel {
  margin-top: 13px;
}
</style>
